import { z } from 'zod';
import { REVIEWABLE_DOCUMENT_TYPES } from '../app-options/index.js';
import { fileSchema } from '../storage/index.js';
export const reviewableDocumentVersionInputSchema = z.object({
    documentTypeId: z.string(),
    fileOne: fileSchema,
    fileTwo: fileSchema.nullish(),
});
export const reviewableDocumentInputSchema = z
    .object({
    id: z.string().nullish(),
    currentVersion: reviewableDocumentVersionInputSchema,
}, {
    // i18n.t('translation:validation.file_required', 'A file is required')
    invalid_type_error: 'translation:validation.file_required',
})
    .superRefine((val, ctx) => {
    const typeId = val.currentVersion.documentTypeId;
    const documentType = Object.values(REVIEWABLE_DOCUMENT_TYPES).find((dt) => dt.id === typeId);
    if (!documentType) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['documentTypeId'],
            // i18n.t('translation:validation.invalid_document_type', 'Invalid document type')
            message: 'translation:validation.invalid_document_type',
        });
        return;
    }
    if (documentType.hasTwoFiles && !val.currentVersion.fileTwo) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['currentVersion.fileTwo'],
            message: 'translation:validation.file_required',
        });
    }
});
//# sourceMappingURL=input-schemas.js.map